import React, { useRef, useState, useEffect } from 'react';
import SwitchInput from '../../components/SwitchInput/SwitchInput';
import { saveLimit } from '../../services/LimitsService';
import { useIntl } from 'react-intl';
import logger from '../../utils/logger';

/**
 * props:
 * - data
 * - onSubmit
 */
function LimitModal(props) {

    const { formatMessage } = useIntl();
    const t = (id) => formatMessage({ id });

    const DEFAULT_LIMIT = {
        name: '',
        maxAutomations: 0,
        maxMonitors: 0,
        maxBacktests: 0,
        isActive: false
    }

    const [error, setError] = useState('');
    const [limit, setLimit] = useState(DEFAULT_LIMIT);
    const btnClose = useRef('');

    function onSubmit(event) {
        saveLimit(limit.id, limit)
            .then(result => {
                btnClose.current.click();
                if (props.onSubmit) props.onSubmit(result);
            })
            .catch(err => {
                logger.error(err.response ? err.response.data : err.message);
                setError(err.message);
            })
    }

    function onInputChange(event) {
        setLimit(prevState => ({ ...prevState, [event.target.id]: event.target.value }));
    }

    useEffect(() => {
        setLimit(props.data);
    }, [props.data.id])

    useEffect(() => {
        const modal = document.getElementById('modalLimit');
        modal.addEventListener('hidden.bs.modal', (event) => {
            setLimit({ ...DEFAULT_LIMIT });
        })
    }, [])

    return (
        <div className="modal fade" id="modalLimit" tabIndex="-1" role="dialog" aria-labelledby="modalTitleNotify" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title" id="modalTitleNotify">{props.data.id ? t('limits.editTitle') : t('limits.newTitle')}</p>
                        <button ref={btnClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <div className="mb-3">
                                <label htmlFor="name">{t('common.name')}:</label>
                                <input type="text" id="name" className="form-control" onChange={onInputChange} value={limit.name || ""} placeholder={t('limits.limitName')} />
                            </div>
                            {/* .gh-grid: 3 → 2 → 1 columns at ANY width, so long German
                                labels never squeeze the number inputs out of the modal. */}
                            <div className="gh-grid mb-3">
                                <div className="form-group">
                                    <label htmlFor="maxAutomations">{t('limits.maxAutomations')}</label>
                                    <input type="number" id="maxAutomations" className="form-control" onChange={onInputChange} value={limit.maxAutomations || ""} placeholder="0" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="maxMonitors">{t('limits.maxMonitors')}</label>
                                    <input type="number" id="maxMonitors" className="form-control" onChange={onInputChange} value={limit.maxMonitors || ""} placeholder="0" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="maxBacktests">{t('limits.maxBacktests')}</label>
                                    <input type="number" id="maxBacktests" className="form-control" onChange={onInputChange} value={limit.maxBacktests || ""} placeholder="0" />
                                </div>
                            </div>
                            <div className="gh-grid gh-grid-wide mb-3">
                                <div className="form-group">
                                    <SwitchInput id="isActive" text={t('limits.isActive')} onChange={onInputChange} isChecked={limit.isActive || false} />
                                </div>
                                <div className="form-group">
                                    <SwitchInput id="hasFutures" text={t('limits.hasFutures')} onChange={onInputChange} isChecked={limit.hasFutures || false} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer flex-wrap gap-2">
                        {
                            error
                                ? <div className="alert alert-danger mt-1 py-1 w-100 mb-0 text-break">{error}</div>
                                : <React.Fragment></React.Fragment>
                        }
                        <button type="button" className="btn btn-sm btn-primary" onClick={onSubmit}>{t('common.save')}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LimitModal;
